import { Button, Input, Modal } from '../../common/_custom';
import CircularSelect from '../../common/MagicUpload/components/CircularSelect/CircularSelect';
import CountryCodesDropdown from '../../modules/Company/CompanyLogin/CountryCodesDropdown/CountryCodesDropdown';
import { DIRECTOR_DESIGNATIONS } from './constants';
import useAddDirectorModalLogic from './useAddDirectorModalLogic';
import { AddDirectorModalProps } from './types';
import styles from './AddDirectorModal.module.scss';

function AddDirectorModal({ open, onClose, onSuccess, organizationId }: AddDirectorModalProps) {
    const { form, errors, saving, setField, handleClose, handleSave, getLabelStyle, fieldFocusHandlers, setPhoneCountryCode } =
        useAddDirectorModalLogic({ open, onClose, onSuccess, organizationId });

    return (
        <Modal open={open} onClose={handleClose} size="flexible" persistent>
            <div className={styles.AddDirectorModal}>
                <div className={styles.Header}>
                    <h3 className={styles.Heading}>Add New</h3>
                </div>
                <div className={styles.Body}>
                    <div className={styles.FieldGroup}>
                        <Input
                            type="text"
                            placeholder="Name"
                            value={form.name}
                            onChange={(value: string) => setField('name', value.slice(0, 255))}
                            errorMessage={errors.name}
                            isValid={!errors.name}
                            containerClassName={styles.FieldContainer}
                            inputClassName={styles.FieldInput}
                            labelStyle={getLabelStyle('name', form.name)}
                            {...fieldFocusHandlers('name')}
                        />
                    </div>

                    <div className={styles.FieldGroup}>
                        <Input
                            type="text"
                            placeholder="PAN"
                            value={form.pan}
                            onChange={(value: string) => setField('pan', value)}
                            errorMessage={errors.pan}
                            isValid={!errors.pan}
                            containerClassName={styles.FieldContainer}
                            inputClassName={styles.FieldInput}
                            labelStyle={getLabelStyle('pan', form.pan)}
                            {...fieldFocusHandlers('pan')}
                        />
                    </div>

                    <div className={styles.FieldGroup}>
                        <div className={styles.PhoneRow}>
                            <CountryCodesDropdown
                                isModal
                                setCountryCode={setPhoneCountryCode}
                                // @ts-ignore — CountryCodesDropdown has no props interface; `style` is untyped there too (see InviteTeammateModal/AddAssessee usage)
                                style={{
                                    width: '6rem',
                                    height: '2.75rem',
                                    borderRadius: '0.25rem',
                                    border: '0.5px solid #D2D2D2',
                                    margin: 0,
                                }}
                            />
                            <Input
                                type="text"
                                placeholder="Phone No (optional)"
                                value={form.phone}
                                onChange={(value: string) => setField('phone', value)}
                                errorMessage={errors.phone}
                                isValid={!errors.phone}
                                maxLength={10}
                                containerClassName={styles.PhoneFieldContainer}
                                inputClassName={styles.FieldInput}
                                labelStyle={getLabelStyle('phone', form.phone)}
                                {...fieldFocusHandlers('phone')}
                            />
                        </div>
                    </div>

                    <div className={styles.FieldGroup}>
                        <label className={styles.FieldLabel}>Designation (optional)</label>
                        <div className={styles.DesignationField}>
                            <CircularSelect
                                option={[...DIRECTOR_DESIGNATIONS]}
                                selectedOption={form.designation}
                                placeholder="Select Designation"
                                addNewText="Add Other"
                                otherOptionPlaceholderText="Enter Designation..."
                                selectClassName={styles.DesignationSelect}
                                onSelect={(value: string) => {
                                    setField('designation', value);
                                    return Promise.resolve(true);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.Footer}>
                    <Button
                        text="Add"
                        variant="primary"
                        size="wide"
                        onClick={handleSave}
                        loading={saving}
                        disabled={saving}
                        className={styles.SaveButton}
                    />
                    <div className={styles.FooterNote}>Note: You cannot change PAN after submission</div>
                </div>
            </div>
        </Modal>
    );
}

export default AddDirectorModal;
